
import PropTypes from 'prop-types';
import React, { Component, createRef  } from 'react';
import { translate } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { 
    Collapse, 
    List,
    Button, 
} from '@material-ui/core';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { Map, TileLayer, Marker, Popup, WMSTileLayer  } from 'react-leaflet'
import Loading from './loading'
import {formatAddress} from '../utils/setting';
const styles = theme => ({
    root: {
      margin: `${theme.spacing(2)}px 0px`,
      height: '480px',
      width: '100%'
    },
});

class LeafletMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openCollapse: true,
            lat: 51.505,
            lng: -0.09,
            zoom: 16,
            checked : false, 
            address : '', 
            lat_center: this.props.lat_center || 10.797336, 
            lng_center: this.props.lng_center || 106.679428, 
            lat_location: "", 
            lng_location: "",            
            bluemarble: false,
        }
        this.refmarker = createRef();
        this.onMarkerChange = this.onMarkerChange.bind(this);
        this.viewOnGoogleMap = this.viewOnGoogleMap.bind(this);
    }

    componentWillMount(){
        this.props.onRef(null);
    }

    componentDidMount(){
        this.props.onRef(this);         
        if(this.props.lat_center && this.props.lng_center && typeof this.props.lat_center === 'number' && typeof this.props.lng_center === 'number'){
            this.setState({ 
                lat_center: this.props.lat_center,
                lng_center: this.props.lng_center,
            })
        }
    }

    componentWillReceiveProps(nextProps){ 
        if(nextProps.lng_center && nextProps.lat_center && typeof nextProps.lat_center === 'number' && typeof nextProps.lng_center === 'number'){
            this.setState({
                lat_center: nextProps.lat_center,
                lng_center: nextProps.lng_center,
            })
        }
    }
    
    async viewOnGoogleMap(address) {
        let {t} = this.props;
        const _this = this;
        if(address){
            await geocodeByAddress(address)
                .then(async results => {
                    return {
                        results: results,
                        latLng: await getLatLng(results[0])
                    }
                })
                .then(async data => {
                    let {results = [], latLng = {}} = data;
                    if(this.props.handleChangeAddress) { 
                        let format = await formatAddress(results[0] || {}, latLng);
                        this.props.handleChangeAddress(format);
                    }
                    let lat = latLng.lat;
                    let lng = latLng.lng;
                    _this.setState({
                        lat_center: lat,
                        lng_center: lng,
                        checked : true
                    }, function(){
                        if(_this.props.handleSubComponentChange !== undefined){
                            _this.props.handleSubComponentChange('lng', lng.toString())
                            _this.props.handleSubComponentChange('lat', lat.toString())
                        }
                    })
                })
                .catch(error => { 
                    if(_this.props.handleOpenSnackBar !== undefined) {
                        _this.setState({checked : false}, function(){
                            _this.props.handleOpenSnackBar(t("googlemap_can't_find_this_address"),'warning')
                        })
                        console.error('Error', error)
                    }                    
                })
            } 
        else {            
            if(_this.props.handleOpenSnackBar !== undefined){
                _this.setState({checked : false}, function(){
                    _this.props.handleOpenSnackBar(t("googlemap_address_can't_empty"),'warning')
                })
            }   
        }

    }
    
    // Lấy latlng mới khi di chuyển marker và cap nhat qua địa chỉ moi tren input
    async onMarkerChange(e) {
        const _this = this;
        let latlng = new window.google.maps.LatLng(e.target._latlng.lat, e.target._latlng.lng);
        
        let geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({
            'latLng': latlng
        }, async(results, status) => { 
            if (status === window.google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                    _this.setState({address : results[0].formatted_address, lat_center: e.target._latlng.lat, lng_center: e.target._latlng.lng}, async function(){
                        if(_this.props.handleChangeAddress !== undefined ){
                            let data = {}
                            let latLng = e.target._latlng || {}
                            this.loading.startLoading()
                            data = await formatAddress(results[0] || {}, {
                                lat: latLng.lat.toString(),
                                lng: latLng.lng.toString()
                            })
                            this.loading.stopLoading()
                            this.props.handleChangeAddress(data)
                        }
                        if(_this.props.handleSubComponentChange !== undefined){ 
                            _this.props.handleSubComponentChange('address', results[0].formatted_address)
                            _this.props.handleSubComponentChange('lng', e.target._latlng.lng.toString())
                            _this.props.handleSubComponentChange('lat', e.target._latlng.lat.toString()) 
                        }
                    })
                } else {             

                }
            } else {
                alert('Geocoder failed due to: ' + status);
            }
        });
    }
    handleOpenMap = () => {
        let { openCollapse } = this.state;
        openCollapse = !openCollapse;
        this.setState({openCollapse})
    }
    render() {
        const { classes, t } = this.props;
        const {lat_center, lng_center, zoom, openCollapse} = this.state;
        const position = [lat_center, lng_center ];
        return (
            <List>
                <div>
                    <Button variant="outlined" color="primary" className={classes.button} onClick={this.handleOpenMap}>
                        {openCollapse ? t('close_map') : t('open_map')}
                    </Button>
                </div>
                <Loading onRef={id => (this.loading = id)}/>
                <Collapse in={openCollapse}>
                    <Map center={position} zoom={zoom} scrollWheelZoom={false} className={classes.root}>
                        <TileLayer
                            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {/* <WMSTileLayer
                            layers={this.state.bluemarble ? 'nasa:bluemarble' : 'ne:ne'}
                            url="https://demo.boundlessgeo.com/geoserver/ows"
                        /> */}
                        <Marker 
                            position={position}
                            draggable={true}
                            onDragend={this.onMarkerChange}
                        >
                            <Popup>
                                A pretty CSS3 popup. <br /> Easily customizable.
                            </Popup>
                        </Marker>
                    </Map>
                </Collapse>
            </List>
        );
    }
}



LeafletMap.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default (translate('translations')(withStyles(styles, { withTheme: true })(LeafletMap)))
